var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSidebarCollapse = function SvgSidebarCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.333H5c-.92 0-1.667.746-1.667 1.667v10c0 .92.746 1.666 1.667 1.666h10c.92 0 1.666-.746 1.666-1.666V5c0-.92-.746-1.667-1.666-1.667zm-2.5 0v13.333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.334 8.333L6.667 10l1.667 1.666"
  }))));
};
export default SvgSidebarCollapse;